import { Suspense } from 'react';
import { v4 as uuid } from 'uuid';
import { Route, Routes } from 'react-router-dom';
import { AdminPrivateRoutes } from 'routes/routes';
import { CustomerRoutes } from 'routes/customerRoutes';

const App = () => (
  <Suspense fallback="loading">
    <Routes>
      {AdminPrivateRoutes.map(({ component, path }) => (
        <Route key={uuid()} element={component} path={path} />
      ))}
      <Route path="/*" element={<CustomerRoutes />} />
    </Routes>
  </Suspense>
);

export default App;
